import React from 'react'
import { LucideIcon } from 'lucide-react'
import { Badge } from '../ui'
import { PriceInput } from './PriceInput'
import { MarginButtonGroup } from '../ui'
import { InfoBox } from '../ui'
import { cn } from '@/lib/utils'

interface PriceFieldCardProps {
  title: string
  icon: LucideIcon
  value: string
  onChange: (value: string) => void
  error?: string
  placeholder?: string
  variant?: 'sale' | 'confidential'
  badgeLabel?: string
  showMarginButtons?: boolean
  onApplyMargin?: (percentage: number) => void
  marginOptions?: Array<{ value: number; label: string; variant?: 'default' | 'negative' }>
  infoMessage?: string
  infoTitle?: string
}

export const PriceFieldCard: React.FC<PriceFieldCardProps> = ({
  title,
  icon: Icon,
  value,
  onChange,
  error,
  placeholder = 'R$ 0,00',
  variant = 'sale',
  badgeLabel,
  showMarginButtons = false,
  onApplyMargin,
  marginOptions,
  infoMessage,
  infoTitle,
}) => {
  const isSale = variant === 'sale'

  return (
    <div
      className={cn(
        'rounded-lg border bg-card p-4',
        isSale
          ? 'border-border border-l-[3px] border-l-emerald-500'
          : 'border-border border-l-[3px] border-l-border',
      )}
    >
      <div className="flex items-center gap-2 mb-3">
        <Icon
          className={cn(
            'h-4 w-4 flex-shrink-0',
            isSale ? 'text-emerald-600 dark:text-emerald-400' : 'text-muted-foreground',
          )}
        />
        <label className="text-sm font-semibold text-foreground flex-1">{title}</label>
        {badgeLabel && (
          <Badge variant={isSale ? 'success' : 'gray'} size="sm">
            {badgeLabel}
          </Badge>
        )}
      </div>

      <div className="space-y-3">
        <PriceInput value={value} onChange={onChange} placeholder={placeholder} />

        {error && <p className="text-xs text-red-600 dark:text-red-400">{error}</p>}

        {showMarginButtons && onApplyMargin && (
          <MarginButtonGroup
            onApply={onApplyMargin}
            options={marginOptions}
            label="Calcular sobre FIPE:"
          />
        )}

        {infoMessage && (
          <InfoBox variant="confidential" title={infoTitle}>
            {infoMessage}
          </InfoBox>
        )}
      </div>
    </div>
  )
}
